import styled, { css } from 'styled-components';
import { primitives } from '@veneer/primitives';

const { color, typography, layout } = primitives;

export interface ContainerProps {
  $position?: 'absolute' | null;
  $background?: string;
}

export const CenterContainer = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  ${({ $position }) =>
    $position === 'absolute'
      ? `position: absolute;
    top: 0;
    left: 0;`
      : null}
  ${({ $background }) => `background-color: ${$background || color.white};`}
`;

const sizeHandler = ({ $size }: { $size: number }) => {
  return css`
    font-size: ${typography[`size${$size}` as keyof typeof typography]};
    line-height: ${typography[
      `lineHeight${$size + 1}` as keyof typeof typography
    ]};
  `;
};

export const Text = styled.p<{ $size: number }>`
  ${sizeHandler}
  margin-top: ${layout.size2};
  text-align: center;
`;
